import { Stack, Table, TableData, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'
import { useViewMode } from '../ViewModeProvider'
import InstitutionalApplicationRecordsChart from './InstitutionalApplicationRecordsChart'

interface InstitutionalApplicationRecordsProps {
  data: any
}

export default function InstitutionalApplicationRecords({ data }: InstitutionalApplicationRecordsProps) {
  const theme = useTheme()
  const { viewMode } = useViewMode()

  const periods = [
    {
      label: '近7天',
      tradCount: data?.b_d7_apply_ctyh_count ?? 0,
      tradOrg: data?.b_d7_apply_ctyh_org_count ?? 0,
      retailCount: data?.b_d7_apply_wllsyh_count ?? 0,
      retailOrg: data?.b_d7_apply_wllsyh_org_count ?? 0,
    },
    {
      label: '近15天',
      tradCount: data?.b_d15_apply_ctyh_count ?? 0,
      tradOrg: data?.b_d15_apply_ctyh_org_count ?? 0,
      retailCount: data?.b_d15_apply_wllsyh_count ?? 0,
      retailOrg: data?.b_d15_apply_wllsyh_org_count ?? 0,
    },
    {
      label: '近1月',
      tradCount: data?.b_m1_apply_ctyh_count ?? 0,
      tradOrg: data?.b_m1_apply_ctyh_org_count ?? 0,
      retailCount: data?.b_m1_apply_wllsyh_count ?? 0,
      retailOrg: data?.b_m1_apply_wllsyh_org_count ?? 0,
    },
    {
      label: '近3月',
      tradCount: data?.b_m3_apply_ctyh_count ?? 0,
      tradOrg: data?.b_m3_apply_ctyh_org_count ?? 0,
      retailCount: data?.b_m3_apply_wllsyh_count ?? 0,
      retailOrg: data?.b_m3_apply_wllsyh_org_count ?? 0,
    },
    {
      label: '近6月',
      tradCount: data?.b_m6_apply_ctyh_count ?? 0,
      tradOrg: data?.b_m6_apply_ctyh_org_count ?? 0,
      retailCount: data?.b_m6_apply_wllsyh_count ?? 0,
      retailOrg: data?.b_m6_apply_wllsyh_org_count ?? 0,
    },
    {
      label: '近1年',
      tradCount: data?.b_m12_apply_ctyh_count ?? 0,
      tradOrg: data?.b_m12_apply_ctyh_org_count ?? 0,
      retailCount: data?.b_m12_apply_wllsyh_count ?? 0,
      retailOrg: data?.b_m12_apply_wllsyh_org_count ?? 0,
    },
  ]

  const tableData: TableData = {
    head: ['统计周期', '传统银行申请次数', '传统银行机构数', '网络零售银行申请次数', '网络零售银行机构数'],
    body: periods.map((period) => [
      period.label,
      period.tradCount,
      period.tradOrg,
      period.retailCount,
      period.retailOrg,
    ]),
  }

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            申请机构类别对比
          </Text>
          <Text size="xs" className="text-gray-500">
            对比传统银行与网络零售银行在不同周期的申请活跃度,关注是否存在集中在单类机构的情况。
          </Text>
        </div>
        {viewMode === 'table' ? (
          <Table
            data={tableData}
            highlightOnHover
            verticalSpacing="sm"
            styles={{
              table: { fontSize: '13px' },
              th: {
                backgroundColor: theme.surfaceMutedColor,
                color: theme.accentTextColor,
              },
            }}
          />
        ) : (
          <InstitutionalApplicationRecordsChart data={data} />
        )}
      </Stack>
    </div>
  )
}
